import { useMutation } from "@tanstack/react-query";
import { sendGoogleAdsInvitation } from "../../api/bGoogleAdsApi";

export const useSendGoogleAdsInvitation = () => {
  return useMutation({
    mutationKey: ["send-google-ads-invitation"],
    mutationFn: (data) => sendGoogleAdsInvitation(data),
    onError: (error) => {
      console.error("Google Ads invitation error details:", error.response || error);
    },
  });
};
